export default __webpack_public_path__ + "static/car-loan-calculator-712bed13f4c8d460e8e4dc5ab834e961.webp";